import { Tooltip, Upload, message } from 'antd';
import { ToolbarIcon } from '../../ToolbarIcon';
import { useTranslate } from '@tolgee/react';
import { platformUploadImageAcceptMap, platformUploadSizeLimitMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { useMemoizedFn } from 'ahooks';
import { RcFile } from 'antd/lib/upload';
import {
  MsgAttachmentInfo,
  useMsgAttachmentList,
  useUploadAttachment,
} from './hooks/useUploadAttachment';
import { uploadClass } from '../styles';

interface AttachmentUploadActionProps {
  conversation: Conversation.Conversation;
}

const UPLOAD_MAX_COUNT = 3;

export const AttachmentUploadActionComponent = (props: {
  channel: General.PlatformUpperCaseTunnel;
  attachmentList: Util.PartialPartial<MsgAttachmentInfo, 'storeId'>[];
  onAttachmentUpload: (file: RcFile) => any;
  children?: JSX.Element;
}) => {
  const { channel, attachmentList, onAttachmentUpload, children } = props;

  const { t } = useTranslate();

  const handleBeforeUpload = useMemoizedFn((file: RcFile, fileList: RcFile[]) => {
    const { [toLowerCase(channel)]: uploadSizeLimit } = platformUploadSizeLimitMap;
    if (fileList.length > UPLOAD_MAX_COUNT || attachmentList.length >= UPLOAD_MAX_COUNT) {
      message.warn(
        t('最多上传count个附件', {
          count: UPLOAD_MAX_COUNT,
        }),
      );
      return Upload.LIST_IGNORE;
    }
    if (file.size > uploadSizeLimit) {
      message.warn(
        t('upload.limitWarn', {
          size: `${(uploadSizeLimit / 1024 / 1024).toFixed(2)}M`,
        }),
      );
      return Upload.LIST_IGNORE;
    }

    onAttachmentUpload(file);

    return Upload.LIST_IGNORE;
  });
  return (
    <Tooltip title={t('添加附件')}>
      <Upload
        className={uploadClass}
        name="file"
        accept={platformUploadImageAcceptMap[toLowerCase(channel)]
          .map((type) => `.${type}`)
          .join(',')}
        multiple
        maxCount={UPLOAD_MAX_COUNT}
        showUploadList={false}
        beforeUpload={handleBeforeUpload}
      >
        {children || <ToolbarIcon icon="attachment" />}
      </Upload>
    </Tooltip>
  );
};

export const AttachmentUploadAction = (props: AttachmentUploadActionProps) => {
  const {
    conversation: { conversationId, channel, storeId, region },
  } = props;
  const uploadAttachment = useUploadAttachment();
  const msgAttachmentList = useMsgAttachmentList(conversationId);

  return (
    <AttachmentUploadActionComponent
      channel={channel}
      attachmentList={msgAttachmentList}
      onAttachmentUpload={(file) => uploadAttachment(conversationId, storeId, region, file)}
    />
  );
};
